import {
  Maybe as HygraphMaybe,
  RowLayout as HygraphRowLayout,
} from '@/lib/types';

import { RowLayout } from '@/enums/row-layout';

const map: Partial<Record<HygraphRowLayout, RowLayout>> = {
  [HygraphRowLayout.FullWide]: RowLayout.FULL_WIDE,
  [HygraphRowLayout.PageWide]: RowLayout.PAGE_WIDE,
  [HygraphRowLayout.MaxWidthCenter]: RowLayout.MAX_WIDTH_CENTER,
  [HygraphRowLayout.MaxWidthCenterWide]: RowLayout.MAX_WIDTH_CENTER_WIDE,
  [HygraphRowLayout.TwoColumnHalfs]: RowLayout.TWO_COLUMN_HALFS,
  [HygraphRowLayout.TwoColumnWideLeft]: RowLayout.TWO_COLUMN_WIDE_LEFT,
  [HygraphRowLayout.TwoColumnWideRight]: RowLayout.TWO_COLUMN_WIDE_RIGHT,
  [HygraphRowLayout.ThreeColumn]: RowLayout.THREE_COLUMN,
  [HygraphRowLayout.FourColumn]: RowLayout.FOUR_COLUMN,
  [HygraphRowLayout.FiveColumn]: RowLayout.FIVE_COLUMN,
  [HygraphRowLayout.TwoColumnNarrowLeft]: RowLayout.TWO_COLUMN_NARROW_LEFT,
  [HygraphRowLayout.TwoColumnNarrowRight]: RowLayout.TWO_COLUMN_NARROW_RIGHT,
  [HygraphRowLayout.NarrowColumnCenter]: RowLayout.NARROW_COLUMN_CENTER,
};

export default function rowLayoutTransformer(
  props: HygraphMaybe<HygraphRowLayout> | undefined
) {
  if (!props) {
    return undefined;
  }

  return map[props];
}
